import styled from 'styled-components';
import { ModalFooter } from './ModalFooter';
import { ModalHeader } from './ModalHeader';
import VStack from '../VStack';
import Box from '../Box';

const ModalWindow: typeof VStack & { Header?: any; Footer?: any; Body?: any } = styled(VStack)({});

ModalWindow.defaultProps = {
  bg: 'secondary.2',
  width: 'fit-content',
  maxWidth: '100%',
  height: 'fit-content',
  borderRadius: '8px 30px 8px 30px',
  padding: '28px',
  margin: 'auto 16px',
};

ModalWindow.Header = ModalHeader;
ModalWindow.Footer = ModalFooter;
ModalWindow.Body = Box;

export default ModalWindow;
